<div class="login-ext-page">
    <div class="col-sx">

    </div>
    <div class="col-dx">
        <teiasoft-login [showIcon]="false" (onKeyEnter)="keyU($event)" (onLoginClick)="onLoginClick($event)" [loginTitle]="'Quotation Tool'"
            [theme]="globals.theme!" [showPasswordRecovery]="false" [courtesyTitle]="'login.title' | translate" 
            [isMobile]="!globals.isDesktop!" [showBorder]="false" [pathLogo]="'./assets/images/Logo_DMV_2024.png'" [appVersion]="globals.appVersion!"></teiasoft-login>
    </div>
</div>
